<template>
  <router-view />
</template>

<script>
import '@/assets/css/theme.css'

export default {
  name: 'App',
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: var(--bg);
}
</style>
